import { Injectable } from '@angular/core';
import {
    FirstAvailableDataTimeStampGQL,
    FirstAvailableDataTimeStampByParkGQL
} from '../graphql';
import {map} from 'rxjs/operators';
import { Observable } from 'rxjs';
import moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class InitialDataService {

    private firstAvailableDataTimestamp: number;

    constructor(
        private firstAvailableDataTimeStampGQL: FirstAvailableDataTimeStampGQL,
        private firstAvailableDataTimeStampByParkGQL: FirstAvailableDataTimeStampByParkGQL,
    ) { }

    public getFirstAvailableDataAsDate(): Observable<Date> {
        return this.firstAvailableDataTimeStampGQL.fetch().pipe(map((e: any) => {
                return new Date(this.calcMinOfParks(e.data.parks));
            }
        ));
    }

    public getFirstAvailableDataAsDateByPark(parkname: string): Observable<Date> {
        return this.firstAvailableDataTimeStampByParkGQL.fetch({
            variables: {parkname}, 
            fetchPolicy: 'network-only' 
        }).pipe(map((e: any) => {
                return e.data.parks[0] === null ? new Date(2018, 1, 1) : new Date(e.data.parks[0].initialData);
            }
        ));
    }

    public getFirstAvailableDataAsTimestampByPark(parkname: string): Observable<number> {
        return this.firstAvailableDataTimeStampByParkGQL.fetch({
            variables: {parkname}, 
            fetchPolicy: 'network-only' 
        }).pipe(map((e: any) => {
            return e.data.parks[0] === null ? moment(new Date(2018, 1, 1)).unix() * 1000 : moment(e.data.parks[0].initialData).unix() * 1000;
            }
        ));
    }

    public getFirstAvailableDataAsTimestamp(): Observable<number> {
        return this.firstAvailableDataTimeStampGQL.fetch().pipe(map((e: any) => {
                return moment(this.calcMinOfParks(e.data.parks)).unix()  * 1000;
            }
        ));
    }

    public getFirstAvailableDataTimestampValue() {
        return this.firstAvailableDataTimestamp;
    }

    public async getFirstAvailableDataTimestamp() {
        this.firstAvailableDataTimestamp = (await this.getFirstAvailableDataAsTimestamp().toPromise());
    }

    private calcMinOfParks(parkList) {
        const parkStartTS = parkList.map(p => p.initialData);
        if (parkStartTS.every((element) => element === null)) {
            return new Date(2018, 1, 1);
        } else {
            parkStartTS.sort();
            return parkStartTS[0];
        }
    }
}
